import { render, staticRenderFns } from "./uplevel-level-avg-stat.vue?vue&type=template&id=a3e0661c&scoped=true&"
import script from "./uplevel-level-avg-stat.vue?vue&type=script&lang=js&"
export * from "./uplevel-level-avg-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e0661c",
  null
  
)

export default component.exports